import { call, put, takeLatest } from "redux-saga/effects";
import { callRedeemPointsPostApi } from "../Context/redeemPointsApi";
import {
  onPostRedeemPoints,
  onPostRedeemPointsError,
  onPostRedeemPointsSuccess,
} from "../Store/Slices/redeemPointsSlice";

function* PostRedeemPoints({ payload }) {
  try {
    const postRedeemPointsResponse = yield call(
      callRedeemPointsPostApi,
      payload
    );
    if (postRedeemPointsResponse.responseCode === "200") {
      yield put(
        onPostRedeemPointsSuccess({
          data: postRedeemPointsResponse.response,
          message: postRedeemPointsResponse.responseMessage,
          status_code: postRedeemPointsResponse.responseCode,
        })
      );
    } else {
      yield put(
        onPostRedeemPointsError({
          data: postRedeemPointsResponse.response,
          message: postRedeemPointsResponse.response.message,
          status_code: postRedeemPointsResponse.responseCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.responseMessage || "Something went wrong";
    yield put(onPostRedeemPointsError({ data: [], message, status_code: 400 }));
  }
}
export default function* redeemPointsSaga() {
  yield takeLatest(onPostRedeemPoints.type, PostRedeemPoints);
}
